export default {
  "女模": "여성 모델",
  "男模": "남성 모델",
  "加载中": "로딩 중",
  "已有账号？": "이미 계정이 있습니까?",
  "去登录": "로그인",
  "首次登录，请选择语言": "첫 로그인, 언어 선택",
  "立即切换": "지금 전환",
    "投注": "賭け",
    "请先绑定银行卡": "은행 카드 연결",
    "服务评分": "서비스 평점",
    "历史": "기록",
    "绑定上限，请联系客服!": "한도 도달, 문의하세요!",
    "已达绑定上限": "연결 한도 도달",
    "任务详情": "작업 상세",
    "投票详情": "투표 상세",
    "获得金额": "획득 금액",
    "待结算": "정산 대기",
    "再来一次": "다시 시도",
    "时间": "시간",
    "备注": "비고",

    accountDetailTab: {
        "充值": '충전',
        "提现": '출금',
        "投票": '투표',
    },
    "选择{name}": "{name} 선택",
    "个人简介": "개인 프로필",
    "投票金额": "투표 금액",
    "投票记录": "투표 기록",
    "投票方向": "투표 방향",
    "下注金额": "베팅 금액",
    "投票": "투표",
    "确认投票": "투표 확인",
    "银行账户号码": "은행 계좌 번호",
    "提现到": "출금 계좌",
    "去绑定": "지금 연결하기",
    "信誉分": "신용 점수",
    "取款方式": "출금 방식",

    "立即预约": "지금 예약",
    "住所": "주소",
    "照片": "사진",
    "胸围": "가슴둘레",
    "约炮推荐": "추천 만남",
    "高端专区": "고급 섹션",
    "暂无信息": "정보 없음",
    "观影券": "영화 관람권",
    "观影券不足": "영화 관람권 부족",
    "详情信息": "상세 정보",
    "银行卡": "은행 카드",
    "x次认证": "{num}회 인증됨",
    "请输入您的收款卡信": "결제 카드 정보를 입력하세요",
    "绑定银行卡": "은행 카드 연결",
    "绑定USDT地址": "USDT 주소 연결",
    "请选择{name}": "{name}을(를) 선택하세요",
    "请输入{name}": "{name}을(를) 입력하세요",
    "银行地址": "은행 주소",
    "银行账户": "은행 계좌",
    "ABA/路由代码": "ABA/라우팅 코드",
    "SWIFT代码": "SWIFT 코드",
    "姓名": "이름",
    "虚拟币": "암호화폐",
    "币种": "통화",
    "地址": "주소",
    "确认绑定": "연결 확인",
    "银行列表": "은행 목록",
    "暂无数据": "데이터 없음",
    "充值": "충전",
    "旧密码": "이전 비번",
    "新密码": "새 비번",
    "请输入您的旧密码": "이전 비번 입력",
    "请输入您的新密码": "새 비번 입력",
    "请再次输入您的新密码": "비번 재입력",
    "修改登录密码": "비번 변경",
    "收款卡信息": "카드 정보",
    "投票结果": "결과",
    tabbar: {
        "首页": "홈",
        "预约": "예약",
        "地区选择": "지역",
        "视频": "영상",
        "我的": "내정보"
    },
    "高端": "고급",
    "认证": "인증",
    "视频认证": "영상 인증",
    "收费区间": "요금 범위",
    "身高": "신장",
    "胸圍": "가슴둘레",
    "服務城市": "서비스 도시",
    "全國空降": "전국 출동",
    "是": "예",
    "否": "아니오",
    "我要约她": "예약",
    "我要约他": "예약",
    "城市大全": "도시 목록",
    "流程价格": "절차 요금",
    "刷新成功": "새로고침 성공",
    "预约大厅": "예약 홀",
    "全部": "전체",
    "查看更多": "더보기",
    "推荐任务": "추천 작업",
    "人气排行": "인기 순위",
    "热门推荐": "인기 추천",
    "获取中": "가져오는 중",
    "语言": "언어",
    "登录": "로그인",
    "忘记密码": "비밀번호 찾기",
    "没有账户？马上注册": "계정 없음? 등록",
    "请输入用户名": "아이디 입력",
    "请输入密码": "비밀번호 입력",
    "注册": "가입",
    "我已经知晓并同意'开户协议'各项条约": "'계좌 개설 약관' 동의",
    "请输入邀请码": "초대 코드 입력",
    "请输入用户名({min}-{max}个英文字母或数字)": "아이디 입력({min}-{max}자)",
    "请输入登录密码({min}-{max}个英文字母或数字)": "비밀번호 입력({min}-{max}자)",
    "请勾选下方开户协议": "약관 동의",
    "可用余额": "사용 가능 잔액",
    "元": "원",
    "提交": "제출",
    "当前选号": "현재 선택",
    "每注金额": "건당 금액",
    "请输入金额": "금액 입력",
    "总共": "총합",
    "注": "건",
    "合计": "합계",
    "任务单": "작업표",
    "1注X{money}元={money}元": "1건X{money}={money}",
    "清空订单": "주문 초기화",
    "确认提交": "제출 확인",
    "期号": "회차",
    "第{x}期": "제{x}회",
    "数据": "데이터",
    "双": "짝수",
    "单": "홀수",
    "未选择": "미선택",
    "金额错误": "금액 오류",
    "请选号": "번호 선택",
    "请填写金额": "금액 입력",
    "余额不足，请联系客服充值！": "잔액 부족, 고객센터 문의!",
    "未选中": "선택 안 됨",
    "请联系管理员领取该任务": "관리자 문의",
    "开奖成功，期号：": "추첨 성공, 회차:",
    "大": "큰",
    "小": "작은",
    "填写收款卡": "카드 정보 입력",
    "请输入您的收款卡信息": "카드 정보 입력",
    "银行卡号": "카드 번호",
    "请输入真实银行卡号": "정확한 카드 번호 입력",
    "银行名称": "은행명",
    "请选择银行": "은행 선택",
    "尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款": "안전 위해 실명 및 비밀번호 설정 필요",
    "确认绑卡": "카드 등록 확인",
    "请输入银行卡号": "카드 번호 입력",
    "任务记录": "작업 기록",
    "任务记录Title": "작업 기록",
    "数据为空": "데이터 없음",
    "下单时间": "주문 시간",
    "结算时间": "정산 시간",
    "提现": "출금",
    "我的钱包": "내 지갑",
    "详情": "상세",
    "余额": "잔액",
    "个人报表": "개인 보고서",
    "账户明细": "계좌 내역",
    "个人中心": "개인 센터",
    "信息公告": "공지 사항",
    "在线客服": "온라인 고객센터",
    "请完成任务单后进入": "작업 완료 후 진행",
    "请联系客服充值": "고객센터 문의",
    "请设置收款卡": "카드 설정 필요",
    "功能已禁用": "기능 비활성화",
    "账号下线": "계정 로그아웃",
    "登录/注册": "로그인/가입",
    "登录可享受更多服务": "로그인 후 더 많은 서비스",
    "基本信息": "기본 정보",
    "头像": "프로필",
    "选择头像": "프로필 선택",
    "确定": "확인",
    "取消": "취소",
    "真实姓名": "실명",
    "未设置": "미설정",
    "性别": "성별",
    "绑定信息": "연동 정보",
    "已绑定": "연동 완료",
    "无": "없음",
    "男": "남성",
    "女": "여성",
    "未知": "미확인",
    "系统公告": "시스템 공지",
    "盈利金额": "수익 금액",
    "盈利计算公式 : 中奖金额 - 任务金额": "수익 = 당첨 - 작업비",
    "任务金额": "작업 금액",
    "充值金额": "충전 금액",
    "提现金额": "출금 금액",
    "中奖金额": "당첨 금액",
    "客服": "고객센터",
    "蜜獾娱乐": "허니배저",
    "联系": "연락",
    "全天7 * 24小时竭诚为您服务": "24시간 고객센터",
    "添加收款卡": "카드 추가",
    "提示:请绑定大型商业银行,如需修改,请您联系在线客服": "대형은행 등록 권장",
    "修改真实姓名": "실명 수정",
    "保存": "저장",
    "请输入真实姓名": "실명 입력",
    "为了您账户安全,真实姓名需要与绑定银行卡姓名一致": "안전 위해 이름 일치 필요",
    "请勿重复设置": "재설정 금지",
    "请输入姓名": "이름 입력",
    "请输入资金密码": "비밀번호 입력",
    "设置资金密码": "비밀번호 설정",
    "请再次输入资金密码": "비밀번호 재입력",
    "请填写完整": "모두 작성",
    "两次密码不一致": "비밀번호 불일치",
    "性别修改": "성별 변경",
    "设置": "설정",
    "基本信息设置": "기본 정보 설정",
    "登录密码": "로그인 비밀번호",
    "资金密码": "출금 비밀번호",
    "退出登录": "로그아웃",
    "已设置": "설정 완료",
    "提现密码已设置，需要修改请联系客服": "비밀번호 변경: 고객센터 문의",
    "提现中心": "출금 센터",
    "提现记录": "출금 기록",
    "1.单笔限额：最低{min}元，最高{max}元": "1회 {min}~{max}",
    "2.提现次数：一天最高提现{num}次": "하루 최대 {num}회",
    "3.到账时间": "도착: 평균 15분, 최장 2시간",
    "限额说明": "한도 설명",
    "马上提现": "즉시 출금",
    "请填写正确的金额": "정확한 금액 입력",
    "金额": "금액",
    "说明": "설명",
    "提交时间": "제출 시간",
    "审核时间": "심사 시간",
    "视频影院": "영상관",
    "没有更多了": "더 이상 없음",
    "播放": "재생",
    "x播放": "x회 재생",
    "首页": "홈",
    "选妃": "선택",
    "选妃列表": "목록",
    "选妃详情": "상세",
    "语言选择": "언어 선택",
    "我的": "내 정보",
    "视频": "영상",
    "游戏": "게임",
    "修改性别": "성별 수정",
    "支付密码管理": "비밀번호 관리",
    "登录密码管理": "로그인 관리",
    "详情页面": "상세 페이지",
    "视频播放": "영상 재생",

    "本期":"현재 기간",
    "剩余时间":"남은 시간",
    "立即投票":"지금 투표하기",
    "提前预订卡进度":"사전 예약 카드 진행 상황",

    "预订状态":"예약 상태",

}
   